import { useQuery } from '@maui/react-query'
import { useVTApiClient } from './client'

export const useGetPrivateAnalysisFiles = ({ id }, options = {}) => {
  const api = useVTApiClient('privateAnalyses')

  return useQuery({
    queryFn: () => api.analysisItem({ id }),
    queryKey: ['analysis', 'item', id],
    select: ({ data }) => data,
    ...options,
    enabled: options.enabled !== false,
  })
}

export const useGetPrivateAnalysisSubmitter = ({ id }, options = {}) => {
  const api = useVTApiClient('privateAnalyses')

  return useQuery({
    queryFn: () => api.analysisSubmitter({ id }),
    queryKey: ['analysis', 'submitter', id],
    select: ({ data }) => data,
    ...options,
    enabled: options.enabled !== false,
  })
}
